import { render, staticRenderFns } from "./MonthViewForTasks.vue?vue&type=template&id=bc531050&scoped=true"
import script from "./MonthViewForTasks.vue?vue&type=script&lang=js"
export * from "./MonthViewForTasks.vue?vue&type=script&lang=js"
import style0 from "./MonthViewForTasks.vue?vue&type=style&index=0&id=bc531050&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc531050",
  null
  
)

export default component.exports